import { LOGOUT_USER } from './actionTypes';

export const logout = error => ({ type: LOGOUT_USER, error });
